import { getSum } from '../../../utilities/getSum';
export function updateRelatives(data, key, check, forceCalculateIntegral = false) {
    const { values, options } = data;
    const currentSum = getSum(values, 'absolute', check);
    let factor = 0;
    if (options.sum) {
        if (options.isSumConstant || forceCalculateIntegral) {
            factor = currentSum > 0 ? options.sum / currentSum : 0;
        }
        else if (values?.[0]) {
            const item = values[0];
            factor = (item[key] || options.sum) / item.absolute;
        }
    }
    data.values = values.map((value) => {
        return {
            ...value,
            ...(check(value) && {
                [key]: value.absolute * factor,
            }),
        };
    });
    if (!options.isSumConstant && !forceCalculateIntegral) {
        options.sum = getSum(values, key, check);
    }
}
